const config = {
    jobberAppUrl: "https://secure.getjobber.com/marketplace/12581",
    docuSignTplUrl: "https://app.docusign.com/templates",
    docuSignHomeUrl: "https://app.docusign.com/home",
    docuSignProducts: "https://www.docusign.ca/products-and-pricing"
};
export default config
